import { Vue, Component } from "vue-property-decorator";
import { LOCALSTORAGE_AUTH2, LOCALSTORAGE_USERSSION } from "../../common/constants";
import { EXTERNAL_APP_URI } from "../../common/uri/property-uri.constants";
import { LanguageHelper } from "../../utils/language-helper";

@Component({
	name: "EmailWebsite",
	template: require("./template.html")
})
export default class EmailWebsite extends Vue {
	auth = null;
	emailAppUrl = "";
	isLoading = true;

	async mounted() {
		this.isLoading = true;
		await this.authenticateAndLoadEmailApp();
	}

	get authConfig() {
		try {
			const authInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH2) || '{}');
			const userInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_USERSSION) || '{}');

			return {
				oauth2: {
					accessToken: authInfo?.data?.oauth2?.accessToken || "",
					refreshToken: authInfo?.data?.oauth2?.refreshToken || "",
					identityToken: authInfo?.data?.oauth2?.identityToken || "",
					accessTokenExpiration: authInfo?.data?.oauth2?.accessTokenExpiration || "",
				},
				information: {
					webAppEndPoint: authInfo?.data?.information?.webAppEndPoint || "",
					webApiEndPoint: authInfo?.data?.information?.webApiEndPoint || "",
					authApiEndPoint: authInfo?.data?.information?.authApiEndPoint || "",
					customerName: authInfo?.data?.information?.customerName || "",
				},
				user: {
					email: userInfo?.UserInfo?.Email || "",
					userName: userInfo?.UserInfo?.Name || "",
					customerId: null,
				},
				languageId: LanguageHelper.convertLanguageInt(this.$i18n.locale),
			};
		} catch (error) {
			console.error("Error parsing authConfig:", error);
			return {};
		}
	}

	async authenticateAndLoadEmailApp() {
		try {
			const authState = this.authConfig;
			if (!authState.oauth2.accessToken) {
				console.error("Authentication failed: Missing access token.");
				this.isLoading = false;
				return;
			}

			const encodedAuthState = encodeURIComponent(JSON.stringify(authState));
			this.emailAppUrl = `${EXTERNAL_APP_URI.EMAIL_APP}?auth_state=${encodedAuthState}`;

			// Delay setting isLoading = false until iframe is fully loaded
		} catch (error) {
			console.error("Error authenticating and loading email app:", error);
			this.isLoading = false;
		}
	}

	// Event handler when the iframe finishes loading
	onIframeLoad() {
		this.isLoading = false;
	}
}